import Splide from '@splidejs/splide'
import { Grid } from '@splidejs/splide-extension-grid'

export default (initialOptions = {
  fixedWidth: 300,
  type: 'loop',
  gap: '20px',
  pagination: false,
}, grid = false) => {
  return {
    init() {
      const splide = new Splide(this.$refs.splide, initialOptions)

      grid ? splide.mount() : splide.mount({ Grid })
    },
  }
}
